module.exports = __webpack_public_path__ + "static/media/ic_paper-airplane.244984f6.svg";